/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useContext } from "react";
import { LayoutContext } from "../../components/layout";
import NotesFields from "./NotesFields";

export const Notes = () => {
  const { headerDetails: userInfo, user } = useContext(LayoutContext);
  const disableAdditionalNotes = userInfo?.readingPhysician?.id === user.id;

  return (
    <fieldset id="additional-notes-section">
      <NotesFields title="Additional Notes" inputName="additionalNotes" disable={disableAdditionalNotes} />
      {userInfo?.readingPhysician?.id === user.id ? (
        <NotesFields title="Provider Notes" inputName="providerNotes" />
      ) : null}
      <p className="bill-status">
        Billing Status (30 Day Cycle):&nbsp;&nbsp;
        <span>{userInfo.thirtyDayBillStatus}</span>
      </p>
      <p className="bill-status">
        Billing Status (90 Day Cycle):&nbsp;&nbsp;
        <span>{userInfo.nintyDayBillStatus}</span>
      </p>
    </fieldset>
  );
};
